import * as button from './button';

$(function () {

    // Submit
    $("#editOption_submit").on("click", function () {
        // ボタンを無効に
        button.invalid(this);

        editOption(document.forms["editOption_Form"], this);
    });
    
});

//　オプションを取得
export function getOption(uuid, thisElem) {
    $.ajax({
        type: 'POST',
        url: mypath + 'home/get/option',
        data: {
            'uuid': uuid
        },
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {

                const album = res['album'];
                const is_email_verified = res['is_email_verified'];

                if (album != null) {
                    document.getElementById("album_uuid").value = album.uuid;
                    document.getElementById("opt_select").checked = album.opt_select;
                    document.getElementById("opt_number").checked = album.opt_number;
                    document.getElementById("opt_caption").checked = album.opt_caption;
                    document.getElementById("opt_protect").checked = album.opt_protect;
                    document.getElementById("opt_public").checked = album.opt_public;
                    document.getElementById("opt_thumtrim").checked = album.opt_thumtrim;
                    document.getElementById("opt_sort").options[album.opt_sort].selected = true;

                    $('.modal_body').css('opacity', '1');

                    // ノーログインアルバムの場合は、セレクトモードをグレーアウト
                    if (album.user_id === null || is_email_verified === false) {
                        document.getElementById('isDisabled').classList.add('set_disabled');
                    } else {
                        document.getElementById('isDisabled').classList.remove('set_disabled');
                    }

                } else {
                    Swal.fire({
                        title: 'エラー',
                        text: '',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // ボタンを有効に
                            button.valid(thisElem);
                        }
                    });
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {
                Swal.fire({
                    title: 'エラー',
                    text: '',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // ボタンを有効に
                        button.valid(thisElem);
                    }
                    console.log(XMLHttpRequest);
                });
            });
}

//　オプション変更
export function editOption(formData, thisElem) {
    $.ajax({
        type: 'POST',
        url: mypath + 'home/edit/option',
        data: $(formData).serialize(),
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {

                if (res['flag']) {

                    // リロード
                    location.reload();
                    
                } else {
                    Swal.fire({
                        title: 'エラー',
                        text: '',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // ボタンを有効に
                            button.valid(thisElem);
                        }
                    });
                    //console.log(res['error']);
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {

                // バリデーションエラー
                if (XMLHttpRequest.responseJSON.errors) {
                    for (let key in XMLHttpRequest.responseJSON.errors) {
                        Swal.fire({
                            title: '入力エラー',
                            text: XMLHttpRequest.responseJSON.errors[key][0],
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                // ボタンを有効に
                                button.valid(thisElem);
                            }
                        });
                        break;
                    }
                } else {
                    Swal.fire({
                        title: 'エラー',
                        text: '',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // ボタンを有効に
                            button.valid(thisElem);
                        }
                    });
                }
            });
}

